import React from 'react';
import classnames from 'classnames';
import { Panel } from 'react-bootstrap';
import LabeledCheckbox from '../LabeledCheckbox.jsx';
import { useStateValue } from '../../context/state.jsx';
import { setProjectFilterStatus } from '../../context/projectFilter.js';

const FilterByStatus = () => {
	const [{ datasets, currentDataset, projectFilter }, dispatch] = useStateValue();

	const datasetInfo = currentDataset && datasets ? datasets[currentDataset] : null;
	if (!datasetInfo) {
		return null;
	}
	const { filterOptions } = datasetInfo;

	const { activityStatus } = projectFilter;

	const handleStatusChange = e => {
		dispatch(setProjectFilterStatus(e.target.value, e.target.checked));
	};

	const statuses = (filterOptions?.activityStatus || []).map((statusCode, index) => {
		const checked = statusCode in projectFilter.activityStatus;
		return (
			<LabeledCheckbox
				key={index}
				text={statusCode}
				textClass={checked ? 'isChecked' : ''}
				value={statusCode}
				checked={checked}
				onChange={handleStatusChange} />
		);
	});
	return (
		<Panel
			className={classnames({activeFilter: Object.keys(activityStatus).length > 0})}>
			<Panel.Heading>
				<Panel.Title toggle>Status</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<Panel.Body>
					<div className="labeledCheckboxGroup">{statuses}</div>
				</Panel.Body>
			</Panel.Collapse>
		</Panel>
	);
};

export default FilterByStatus;
